import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader, Section } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        
        <PageHeader {...page} subheading="If there are no units available at a store and the user wants to be added to a waitlist, collect their information." >Waitlist</PageHeader>    
        
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingWaitlistCollectProfile} label="Collect Profile" />
        <Section {...page} hideIf= {IS_NOT_EQUAL(LocationVarKey.ProfileSettingWaitlistCollectProfile, "1")}>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.ProfileSettingWaitlistMessage}
        />
        <DropdownRow {...page} 
        marginTop
        label=" Collection Method"
        keyName= {LocationVarKey.ProfileSettingWaitlistCollectionMethod}
        options={[
            {
                label:"Conversational",
                value:"Conversational"
            },
            {
                label:"Info Collect Card",
                value:"Card"
            }
        ]} />
        <DropdownRow {...page} 
        marginTop
        label=" Preferred Contact Method"
        keyName= {LocationVarKey.ProfileSettingWaitlistContactMethod}
        options={[
            {
                label:"Phone Number",
                value:"Phone"
            },
            {
                label:"Email",
                value:"Email"
            }
        ]} />
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingWaitlistWantShortProfile} label="Short Profile" />
        <Indent {...page} >
            <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingWaitlistWantSecondaryOptional} hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingWaitlistWantShortProfile,"1")} label="Make Secondary Contact Method Optional" />
        </Indent>
        <SwitchRow {...page}  keyName= {LocationVarKey.ProfileSettingWaitlistWantConfirmProfile} label="Confirm Profile" />
        </Section>  


    </>
}